/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SpinnerIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "spinner", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SpinnerIcon);
export default ForwardRef;
//# sourceMappingURL=spinnerIcon.js.map